// src/utils/locales.js
export const TEXTS = {
    ru: {
        currency: "₽",
        cart: {
            title: "Корзина",
            empty: "Ваша корзина пуста",
            pay_btn: "Оформить заказ",
            total: "Итого",
            add: "Добавить",
            remove: "Удалить"
        },
        checkout: {
            title: "Оформление заказа",
            payment_method: "Способ оплаты",
            cash: "Наличными",
            card: "Картой онлайн",
            delivery: "Доставка",
            pickup: "Самовывоз",
            address_label: "Адрес доставки",
            phone_label: "Номер телефона",
            comment_label: "Комментарий к заказу",
            submit_btn: "Подтвердить заказ",
            errors: {
                min_amount: "Минимальная сумма заказа: "
            }
        },
        profile: {
            title: "Профиль",
            bonus_balance: "Бонусов на счету",
            history: "История заказов"
        }
    }
};

// Простой хук для использования (пока без i18next ради легкости)
export const useText = () => TEXTS.ru;
